<template>
  <VanPopup
    v-model:show="modalStore.showEnterAppModal"
    :close-on-click-overlay="false"
  >
    <div class="card bg-base-100 w-full max-w-md mx-auto rounded-box">
      <div class="card-body p-4">
        <h2 class="card-title text-center font-bold mb-2">温馨提示</h2>

        <div class="text-sm mb-4">
          <p class="mb-2">
            欢迎您使用饼次元APP！我们非常重视您的个人信息和隐私保护，我们将通过《隐私权保护政策》帮助您了解我们收集、使用、存储、共享和保护个人信息的情况，以及您所享有的相关权利。
          </p>

          <ol class="space-y-2">
            <li class="list-decimal list-inside">
              为了更好的向您提供注册认证、发布信息、交流互动、搜索查询、线上交易等相关服务功能，我们会收集、使用必要的信息；
            </li>
            <li class="list-decimal list-inside">
              基于您的授权我们可能会获取您的位置等信息，您有权拒绝或取消授权；
            </li>
          </ol>

          <div class="mt-3">
            请您阅读
            <span
              @click="
                clickPolicy(isCN ? 'user-agreement-cn' : 'terms-of-service')
              "
              class="text-primary cursor-pointer"
            >
              {{ $t("loginmodal.userAgreement") }} </span
            >和
            <span
              @click="
                clickPolicy(isCN ? 'privacy-policy-cn' : 'privacy-policy')
              "
              class="text-primary cursor-pointer"
            >
              {{ $t("loginmodal.privacyPolicy") }}
            </span>
          </div>
        </div>

        <div class="card-actions justify-center flex flex-col gap-2">
          <button
            class="btn btn-primary btn-block rounded-full"
            @click="onAgree"
          >
            同意并进入
          </button>
          <button class="btn btn-ghost btn-block" @click="onExit">退出</button>
        </div>
      </div>
    </div>

    <ModalPolicyPage v-model:show="showPolicy" :docType="policyType" />
  </VanPopup>
</template>

<script setup lang="ts">
import { inApp } from "@/modules/common";
import { useGlobalModal } from "@/stores/globalModal";
import { useJsBridgeStore } from "@/stores/jsBridge";
import { StorageSet } from "@/tools/localStorage";
import { ref } from "vue";

const isCN = !!import.meta.env.VITE_IS_CN;
const modalStore = useGlobalModal();
const jsBridgeStore = useJsBridgeStore();

const onAgree = () => {
  StorageSet(`AGREE_ENTER_APP`, true);

  modalStore.showEnterAppModal = false;
  // 这里可以添加同意后的逻辑
};

const showPolicy = ref(false);
const policyType = ref("");
const clickPolicy = (type: string) => {
  policyType.value = type;
  showPolicy.value = true;
};
const onExit = async () => {
  // show.value = false;
  // 这里可以添加退出的逻辑
  if (inApp) {
    await jsBridgeStore.callQuitAppHandler();
  } else {
    window.close();
  }
};
</script>
